import { Component } from '@angular/core';
import { AlertService, AuthService } from '@app/core/services';
import { BaseContextmenuComponent } from './base-contextmenu.component';


@Component({
  selector: 'service-contextmenu',
  template: `
    <kendo-contextmenu (select)="onSelect($event)">
      <kendo-menu-item url="detalle">
        <ng-template kendoMenuItemTemplate let-item="item">
          <div class="menu-header">
            <span class="k-icon k-i-information"></span>
            Servicio: {{contextItem.crane_name}}
          </div>
        </ng-template>
      </kendo-menu-item>
      <kendo-menu-item url="editar" text="Editar" icon="edit" *ngIf="this.authService.hasPermission(['SALIDAS_SERVICIOS:EDITAR']) && contextItem?.entry_date == null"></kendo-menu-item>
      <kendo-menu-item url="eliminar" text="Eliminar" icon="trash" *ngIf="this.authService.hasPermission(['SALIDAS_SERVICIOS:ELIMINAR']) && contextItem?.entry_date == null"></kendo-menu-item>      
      <kendo-menu-item [separator]="true" *ngIf="(this.authService.hasPermission(['RECEPCIONES_SERVICIOS:EDITAR']) && contextItem?.entry_date == null) || (this.authService.hasPermission(['RECEPCIONES_SERVICIOS:ELIMINAR']) && contextItem?.entry_date != null)"></kendo-menu-item>
      <kendo-menu-item url="factura" text="Actualizar factura" icon="file" *ngIf="this.authService.hasPermission(['SALIDAS_SERVICIOS:EDITAR']) && (contextItem?.id_service_status == 2 || contextItem?.id_service_status == 4)"></kendo-menu-item>
      <kendo-menu-item url="recepcion" text="Recepción" icon="arrow-right" *ngIf="this.authService.hasPermission(['RECEPCIONES_SERVICIOS:EDITAR']) && (contextItem?.id_service_status == 1 || contextItem?.id_service_status == 3)"></kendo-menu-item>
      <kendo-menu-item url="eliminar_recepcion" text="Cancelar recepción" icon="cancel" *ngIf="this.authService.hasPermission(['RECEPCIONES_SERVICIOS:ELIMINAR']) && contextItem?.entry_date != null"></kendo-menu-item>      
    </kendo-contextmenu>`,
  styles: [`
    .menu-header {
      color: #ff6358
    }
  `]
})
export class ServiceContextmenuComponent extends BaseContextmenuComponent {  

  //Overrides
  constructor(protected authService: AuthService, protected alertService: AlertService) {
            
    super(authService, alertService);
    // console.log(this.constructor.name);   
    
  }

  //Overrides
  protected onSelect(event): void {

    // console.log(this.constructor.name + ":onSelect", event.item, this.contextItem);
    
    event.preventDefault();
    let url: string = event.item.url;

    if (url === 'editar') {

      // Editar

    } else if (url === 'eliminar') {
        
      // Eliminar

    } else if (url === 'recepcion') {
        
      // Recepción

    } else if (url === 'eliminar_recepcion') {
        
      // Eliminar Recepción

    } else if (url === 'factura') {
        
      // Actualizar Factura

    }

    //Emitir evento: selected
    this.select.emit({menu: event.item, contextItem: this.contextItem});

  }

}
